<template>
  <div>
    <!--기본정보-->
    <field-select-module
      v-model="form.stdInfo"
      :board="board"
      :fieldReadonly="board.readonly"
      :is-print="isPrint || board.readonly"
      :options="[{ type: 'text', label: '문서번호', readonly: true, visibleWhenValue: true}]"
      vislbleAlert
    />

    <!-- 문서정보 -->
    <write-grid-container
      title="문서정보"
      v-model="form.문서정보"
      :options="{
        dataTypes: ['select_보안등급', 'select_보존년한'],
        labels: ['보안등급', '보존년한'],
        values: ['보안등급', '보존년한'],
      }"
      class="page-break mt-7">
      <template slot-scope="{ index, label, value, dataType }">
        <div v-if="isPrint || board.readonly">
          <div class="print-input">{{ form.문서정보[value] }}</div>
        </div>

        <div v-else class="write-grid-container-col">
          <custom-option-selector v-if="dataType === 'select_보안등급'"
                                  class="w-full"
                                  v-model="form.문서정보[value]"
                                  :options="['사내', '그룹사내', '팀내', '제한']" />
          <custom-option-selector v-else-if="dataType === 'select_보존년한'"
                                  class="w-full"
                                  v-model="form.문서정보[value]"
                                  :options="[
                                    {text:'1년', value: 1},
                                    {text:'3년', value: 3},
                                    {text:'5년', value: 5},
                                    {text:'7년', value: 7},
                                    {text:'10년', value: 10},
                                    {text:'영구', value: -1}]" />
          <ml-input v-else class="w-full" v-model="form.문서정보[value]" visible-counter :max="100" />
        </div>
      </template>
    </write-grid-container>

    <!-- 평가정보 -->
    <write-grid-container
      title="평가정보"
      v-model="form.평가정보"
      :options="{
        dataTypes: ['date', 'date', 'text', 'radio'],
        labels: ['신청일', '평가일', '담당자', '직영/협력'],
        values: ['신청일', '평가일', '담당자', '직영협력'],
      }"
      class="page-break mt-7">
      <template slot-scope="{ index, label, value, dataType }">
        <div v-if="isPrint || board.readonly" >
          <div class="print-input">{{ form.평가정보[value] }}</div>
        </div>

        <div v-else class="write-grid-container-col">
          <date-selector v-if="dataType === 'date'" class="w-full" v-model="form.평가정보[value]" />
          <radio-group v-else-if="dataType === 'radio'" class="w-full" :items="['직영', '협력']" flex v-model="form.평가정보[value]" />
          <ml-input v-else class="w-full" v-model="form.평가정보[value]" visible-counter :max="100" />
        </div>
      </template>
    </write-grid-container>

    <!-- 공정분류 -->
    <write-grid-container
      title="공정분류"
      v-model="form.공정분류"
      :options="{
        dataTypes: ['readonly', 'readonly', 'readonly', 'readonly', 'readonly', 'select_관리유형', 'radio_구분'],
        labels: ['팀명', '공장명', '공정명', '상태', '활동명', '관리유형', '구분'],
        values: ['팀명', '공장명', '공정명', '상태', '활동명', '관리유형', '구분'],
      }"
      class="page-break mt-7">
      <template #topRight>
        <select891-button v-if="!(isPrint || board.readonly)" v-model="form.공정분류.raw" @input="onSelectProcess"/>
      </template>

      <template slot-scope="{ index, label, value, dataType }">
        <div v-if="isPrint || board.readonly" >
          <div class="print-input">{{ form.공정분류[value] }}</div>
        </div>

        <div v-else class="write-grid-container-col">
          <custom-option-selector v-if="dataType === 'select_관리유형'"
                                  class="w-full"
                                  v-model="form.공정분류[value]"
                                  :options="['직접', '간접']" />
          <radio-group v-else-if="dataType === 'radio_구분'" class="w-full" :items="['정기', '수시']" flex v-model="form.공정분류[value]" />
          <ml-input v-else class="w-full" readonly v-model="form.공정분류[value]" visible-counter :max="100" />
        </div>
      </template>
    </write-grid-container>

    <!-- 사용물질 정보 -->
    <table-custom
      class="mt-7"
      :board="board"
      :is-print="isPrint "
      title="사용물질 정보"
      :tableData="[
        { id: '사용물질1', title: '사용물질', type: 'text', className: 'align-center', placeholder: '' },
        { id: '사용량1', title: '사용량', type: 'customType', className: 'align-center', placeholder: '', defaultValue: {label: '', unit: 'Kg/월', unit_기타: ''} },
        { id: '사용물질2', title: '사용물질', type: 'text', className: 'align-center', placeholder: '' },
        { id: '사용량2', title: '사용량', type: 'customType', className: 'align-center', placeholder: '', defaultValue: {label: '', unit: 'Kg/월', unit_기타: ''} },
        { id: '사용물질3', title: '사용물질', type: 'text', className: 'align-center', placeholder: '' },
        { id: '사용량3', title: '사용량', type: 'customType', className: 'align-center', placeholder: '', defaultValue: {label: '', unit: 'Kg/월', unit_기타: ''} },
      ]"
      :mobile="['사용물질1', '사용량1']"
      v-model="form.사용물질정보"
    >
      <template #mobileTableColumns="{mobileData, trData, value}">
        <div v-if="mobileData === '사용량1'"> {{value.label}} {{value.unit === '기타' ? value.unit_기타 : value.unit}}</div>
      </template>
      <template #customType="{ trData, id, index, input, noteIndex }">
        <div v-if="isPrint || board.readonly" class="grid gap-2 items-center">
          <div class="print-input">{{ form.사용물질정보[index][id].label }}</div>
          <div class="grid gap-2" >
            <div v-if="isPrint" class="print-input">{{form.사용물질정보[index][id].unit}}</div>
            <custom-option-selector v-else class="w-full" :disabled="true" v-model="form.사용물질정보[index][id].unit" :options="[
              'Kg/월', 'Ton/월', 'Kwh/월', 'L/월', 'Kg/일',
              'Ton/일', 'Kwh/일', 'L/일', 'Kg/회', 'Ton/회',
              'Kwh/회', 'L/회', 'KL/회', 'Set/회', '개/회',
              '대/회', '기타'
            ]"/>
            <div v-if="form.사용물질정보[index][id].unit === '기타'" class="w-full print-input">
              {{ form.사용물질정보[index][id].unit_기타 }}
            </div>
          </div>
        </div>
        <div v-else class="flex gap-2 items-center">
          <ml-input v-model="form.사용물질정보[index][id].label"/>
          <div class="grid gap-2">
            <custom-option-selector class="w-full" v-model="form.사용물질정보[index][id].unit" :options="[
              'Kg/월', 'Ton/월', 'Kwh/월', 'L/월', 'Kg/일',
              'Ton/일', 'Kwh/일', 'L/일', 'Kg/회', 'Ton/회',
              'Kwh/회', 'L/회', 'KL/회', 'Set/회', '개/회',
              '대/회', '기타'
            ]"/>
            <ml-input v-if="form.사용물질정보[index][id].unit === '기타'"
                      class="w-full"
                      v-model="form.사용물질정보[index][id].unit_기타"/>
          </div>
        </div>
      </template>
    </table-custom>

    <!-- 환경영향 평가 -->
    <div v-if="isPrint" class="mt-7">
      <div class="mb-4">
        <div class="flex flex-wrap items-center justify-start gap-3">
          <h5><i class="dot"></i>환경영향 평가</h5>
          <span v-if="!(isPrint || board.readonly)" class="cursor-pointer flex gap-1 items-center" style="color:#7E72F2;" @click="showHowToWrite = true;">
            <feather-icon icon="AlertCircleIcon" class="w-5 h-5"/>
            작성방법
          </span>
          <div class="ml-auto"></div>
        </div>
      </div>
      <div class="overflow-x-auto">
        <table>
          <colgroup>
            <col width="43px" />
            <col width="186px" />
            <col width="185px" />
          </colgroup>
          <thead>
          <tr>
            <th rowspan="2">No.</th>
            <th rowspan="2">배출물질</th>
            <th rowspan="2">배출량</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(환경영향평가Item, rowIndex) in form.환경영향평가.list">
            <th>{{ rowIndex +1 }}</th>
            <!-- 환경영향평가.배출물질 -->
            <td>
              <div v-if="isPrint || board.readonly" class="print-input">{{ 환경영향평가Item.배출물질 }}</div>
              <ml-input v-else v-model="환경영향평가Item.배출물질"/>
            </td>
            <!-- 환경영향평가.배출량 -->
            <td>
              <div v-if="isPrint || board.readonly" class="flex gap-2 items-center">
                <div class="print-input">{{환경영향평가Item.배출량.label}}</div>
                <div class="grid gap-2" style="width: 120px;">
                  <div v-if="isPrint || board.readonly" class="print-input">{{ 환경영향평가Item.배출량.unit }}</div>
                  <custom-option-selector v-else class="w-full"
                                          v-model="환경영향평가Item.배출량.unit"
                                          :disabled="true"
                                          :options="[
                                            'Kg/월', 'Ton/월', 'Kwh/월', 'L/월', 'Kg/일',
                                            'Ton/일', 'Kwh/일', 'L/일', 'Kg/회', 'Ton/회',
                                            'Kwh/회', 'L/회', 'KL/회', 'Set/회', '개/회',
                                            '대/회', '기타'
                                          ]"/>
                  <div v-if="환경영향평가Item.배출량.unit === '기타'"
                       class="w-full print-input">{{환경영향평가Item.배출량.unit_기타}}</div>
                </div>
              </div>
              <div v-else class="flex gap-2 items-center">
                <ml-input v-model="환경영향평가Item.배출량.label"/>
                <div class="grid gap-2">
                  <custom-option-selector class="w-full"
                                          v-model="환경영향평가Item.배출량.unit"
                                          :options="[
                                            'Kg/월', 'Ton/월', 'Kwh/월', 'L/월', 'Kg/일',
                                            'Ton/일', 'Kwh/일', 'L/일', 'Kg/회', 'Ton/회',
                                            'Kwh/회', 'L/회', 'KL/회', 'Set/회', '개/회',
                                            '대/회', '기타'
                                          ]"/>
                  <ml-input v-if="환경영향평가Item.배출량.unit === '기타'"
                            class="w-full"
                            v-model="환경영향평가Item.배출량.unit_기타"/>
                </div>
              </div>
            </td>
          </tr>
          </tbody>
        </table>

        <table>
          <colgroup>
            <col width="126" />
            <col width="70" />
            <col width="70" />
            <col width="70" />
            <col width="70" />
            <col width="100" />
            <col width="80" />
            <col width="156" />
          </colgroup>
          <thead>
          <tr>
            <th colspan="2">환경요소</th>
            <th colspan="3">발생 가능성</th>
            <th colspan="2">중요도</th>
            <th rowspan="2">환경영향</th>
          </tr>
          <tr>
            <th>평가</th>
            <th>심각도</th>
            <th>검출도</th>
            <th>확률</th>
            <th>점수</th>
            <th>점수</th>
            <th>등급</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(환경영향평가Item, rowIndex) in form.환경영향평가.list">
            <!-- 환경영향평가.list -->
            <td v-if="rowIndex === 0" :rowspan="form.환경영향평가.list.length" class="align-top">
              <div class="grid gap-2">
                <template v-if="isPrint">
                  <span v-for="(item, index) in ['대기', '소음진동', '수질', '폐기물', '토양', '에너지', '천연자원', '생태계']" class="print-checkbox">
                    <i><feather-icon v-if="form.환경영향평가.환경요소_평가.indexOf(item) !== -1" svgClasses="w-4 w-5" icon="CheckIcon" /></i>
                    {{ item }}
                  </span>
                </template>
                <template v-else>
                  <vs-checkbox v-for="(item, index) in ['대기', '소음진동', '수질', '폐기물', '토양', '에너지', '천연자원', '생태계']" :key="`환경영향평가.list_${item}`"
                               class="m-0"
                               color="secondary"
                               :disabled="isPrint || board.readonly"
                               :vs-value="item"
                               :checked="form.환경영향평가.환경요소_평가.indexOf(item) !== -1"
                               :isPrint="isPrint"
                               @change="onChangeCheck(form.환경영향평가.환경요소_평가, item)">{{ item }}</vs-checkbox>
                </template>
              </div>
            </td>
            <!-- 환경영향평가.환경요소_심각도 -->
            <td v-if="rowIndex === 0" :rowspan="form.환경영향평가.list.length" class="align-top ">
              <div v-if="isPrint" class="print-input">{{form.환경영향평가.환경요소_심각도 || '0'}}</div>
              <ml-input v-else textAlign="center" :value="form.환경영향평가.환경요소_심각도 || '0'" readonly/></td>
            <!-- 환경영향평가.발생가능성_검출도 -->
            <td v-if="rowIndex === 0" :rowspan="form.환경영향평가.list.length" class="align-top">
              <div v-if="isPrint" class="print-input">{{form.환경영향평가.발생가능성_검출도 || '0'}}</div>
              <ml-input v-else textAlign="center" :value="form.환경영향평가.발생가능성_검출도 || '0'" readonly/></td>
            <!-- 환경영향평가.발생가능성_확률 -->
            <td v-if="rowIndex === 0" :rowspan="form.환경영향평가.list.length" class="align-top">
              <div v-if="isPrint" class="print-input">{{form.환경영향평가.발생가능성_확률 || '0'}}</div>
              <ml-input v-else textAlign="center" :value="form.환경영향평가.발생가능성_확률 || '0'" readonly/></td>
            <!-- 환경영향평가.발생가능성_점수 -->
            <td v-if="rowIndex === 0" :rowspan="form.환경영향평가.list.length" class="align-top">
              <div v-if="isPrint" class="print-input">{{form.환경영향평가.발생가능성_점수 || '0'}}</div>
              <ml-input v-else textAlign="center" :value="form.환경영향평가.발생가능성_점수 || '0'" readonly/></td>
            <!-- 환경영향평가.중요도_점수 -->
            <td v-if="rowIndex === 0" :rowspan="form.환경영향평가.list.length" class="align-top">
              <div v-if="isPrint" class="print-input">{{form.환경영향평가.중요도_점수 || '0'}}</div>
              <ml-input v-else textAlign="center" :value="form.환경영향평가.중요도_점수 || '0'" readonly/></td>
            <!-- 환경영향평가.중요도_등급 -->
            <td v-if="rowIndex === 0" :rowspan="form.환경영향평가.list.length" class="align-top">
              <div v-if="isPrint" class="print-input">{{`${getRating(form.환경영향평가.중요도_점수).name}(${form.환경영향평가.중요도_점수})`}}</div>
              <ml-input v-else
                        textAlign="center"
                        readonly
                        :style="{color: getRating(form.환경영향평가.중요도_점수).color}"
                        :value="`${getRating(form.환경영향평가.중요도_점수).name}(${form.환경영향평가.중요도_점수})`"
              /></td>
            <!-- 환경영향평가.환경영향 -->
            <td v-if="rowIndex === 0" :rowspan="form.환경영향평가.list.length" class="align-top">
              <div v-if="isPrint" class="print-input">{{form.환경영향평가.환경영향 || '0'}}</div>
              <ml-input v-else textAlign="center" :value="form.환경영향평가.환경영향" readonly/></td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div v-else class="mt-7">
      <div class="mb-4">
        <div class="flex flex-wrap items-center justify-start gap-3">
          <h5><i class="dot"></i>환경영향 평가</h5>
          <span v-if="!(isPrint || board.readonly)" class="cursor-pointer flex gap-1 items-center" style="color:#7E72F2;" @click="showHowToWrite = true;">
            <feather-icon icon="AlertCircleIcon" class="w-5 h-5"/>
            작성방법
          </span>
          <div class="ml-auto"></div>
        </div>
      </div>
      <div class="overflow-x-auto">
        <table>
          <colgroup>
            <col width="43px" />
            <col width="186" />
            <col width="185" />
            <col width="126" />
            <col width="70" />
            <col width="70" />
            <col width="70" />
            <col width="70" />
            <col width="100" />
            <col width="80" />
            <col width="156" />
          </colgroup>
          <thead>
          <tr>
            <th rowspan="2">No.</th>
            <th rowspan="2">배출물질</th>
            <th rowspan="2">배출량</th>
            <th colspan="2">환경요소</th>
            <th colspan="3">발생 가능성</th>
            <th colspan="2">중요도</th>
            <th rowspan="2">환경영향</th>
          </tr>
          <tr>
            <th>평가</th>
            <th>심각도</th>
            <th>검출도</th>
            <th>확률</th>
            <th>점수</th>
            <th>점수</th>
            <th>등급</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(환경영향평가Item, rowIndex) in form.환경영향평가.list">
            <th>{{ rowIndex +1 }}</th>
            <!-- 환경영향평가.배출물질 -->
            <td>
              <div v-if="isPrint || board.readonly" class="print-input">{{ 환경영향평가Item.배출물질 }}</div>
              <ml-input v-else v-model="환경영향평가Item.배출물질"/>
            </td>
            <!-- 환경영향평가.배출량 -->
            <td>
              <div v-if="isPrint || board.readonly" class="flex gap-2 items-center">
                <div class="print-input">{{환경영향평가Item.배출량.label}}</div>
                <div class="grid gap-2">
                  <div v-if="isPrint || board.readonly" class="print-input">{{ 환경영향평가Item.배출량.unit }}</div>
                  <custom-option-selector v-else class="w-full"
                                          v-model="환경영향평가Item.배출량.unit"
                                          :disabled="true"
                                          :options="[
                                            'Kg/월', 'Ton/월', 'Kwh/월', 'L/월', 'Kg/일',
                                            'Ton/일', 'Kwh/일', 'L/일', 'Kg/회', 'Ton/회',
                                            'Kwh/회', 'L/회', 'KL/회', 'Set/회', '개/회',
                                            '대/회', '기타'
                                          ]"/>
                  <div v-if="환경영향평가Item.배출량.unit === '기타'"
                       class="w-full print-input">{{환경영향평가Item.배출량.unit_기타}}</div>
                </div>
              </div>
              <div v-else class="flex gap-2 items-center">
                <ml-input v-model="환경영향평가Item.배출량.label"/>
                <div class="grid gap-2">
                  <custom-option-selector class="w-full"
                                          v-model="환경영향평가Item.배출량.unit"
                                          :options="[
                                            'Kg/월', 'Ton/월', 'Kwh/월', 'L/월', 'Kg/일',
                                            'Ton/일', 'Kwh/일', 'L/일', 'Kg/회', 'Ton/회',
                                            'Kwh/회', 'L/회', 'KL/회', 'Set/회', '개/회',
                                            '대/회', '기타'
                                          ]"/>
                  <ml-input v-if="환경영향평가Item.배출량.unit === '기타'"
                            class="w-full"
                            v-model="환경영향평가Item.배출량.unit_기타"/>
                </div>
              </div>
            </td>
            <!-- 환경영향평가.list -->
            <td v-if="rowIndex === 0" :rowspan="form.환경영향평가.list.length" class="align-top">
              <div class="grid gap-2">
                <template v-if="isPrint">
                  <span v-for="(item, index) in ['대기', '소음진동', '수질', '폐기물', '토양', '에너지', '천연자원', '생태계']" class="print-checkbox">
                    <i><feather-icon v-if="form.환경영향평가.환경요소_평가.indexOf(item) !== -1" svgClasses="w-4 w-5" icon="CheckIcon" /></i>
                    {{ item }}
                  </span>
                </template>
                <template v-else>
                  <vs-checkbox v-for="(item, index) in ['대기', '소음진동', '수질', '폐기물', '토양', '에너지', '천연자원', '생태계']" :key="`환경영향평가.list_${item}`"
                               class="m-0"
                               color="secondary"
                               :disabled="isPrint || board.readonly"
                               :vs-value="item"
                               :checked="form.환경영향평가.환경요소_평가.indexOf(item) !== -1"
                               :isPrint="isPrint"
                               @change="onChangeCheck(form.환경영향평가.환경요소_평가, item)">{{ item }}</vs-checkbox>
                </template>
              </div>
            </td>
            <!-- 환경영향평가.환경요소_심각도 -->
            <td v-if="rowIndex === 0" :rowspan="form.환경영향평가.list.length" class="align-top ">
              <div v-if="isPrint" class="print-input">{{form.환경영향평가.환경요소_심각도 || '0'}}</div>
              <ml-input v-else textAlign="center" :value="form.환경영향평가.환경요소_심각도 || '0'" readonly/></td>
            <!-- 환경영향평가.발생가능성_검출도 -->
            <td v-if="rowIndex === 0" :rowspan="form.환경영향평가.list.length" class="align-top">
              <div v-if="isPrint" class="print-input">{{form.환경영향평가.발생가능성_검출도 || '0'}}</div>
              <ml-input v-else textAlign="center" :value="form.환경영향평가.발생가능성_검출도 || '0'" readonly/></td>
            <!-- 환경영향평가.발생가능성_확률 -->
            <td v-if="rowIndex === 0" :rowspan="form.환경영향평가.list.length" class="align-top">
              <div v-if="isPrint" class="print-input">{{form.환경영향평가.발생가능성_확률 || '0'}}</div>
              <ml-input v-else textAlign="center" :value="form.환경영향평가.발생가능성_확률 || '0'" readonly/></td>
            <!-- 환경영향평가.발생가능성_점수 -->
            <td v-if="rowIndex === 0" :rowspan="form.환경영향평가.list.length" class="align-top">
              <div v-if="isPrint" class="print-input">{{form.환경영향평가.발생가능성_점수 || '0'}}</div>
              <ml-input v-else textAlign="center" :value="form.환경영향평가.발생가능성_점수 || '0'" readonly/></td>
            <!-- 환경영향평가.중요도_점수 -->
            <td v-if="rowIndex === 0" :rowspan="form.환경영향평가.list.length" class="align-top">
              <div v-if="isPrint" class="print-input">{{form.환경영향평가.중요도_점수 || '0'}}</div>
              <ml-input v-else textAlign="center" :value="form.환경영향평가.중요도_점수 || '0'" readonly/></td>
            <!-- 환경영향평가.중요도_등급 -->
            <td v-if="rowIndex === 0" :rowspan="form.환경영향평가.list.length" class="align-top">
              <div v-if="isPrint" class="print-input">{{`${getRating(form.환경영향평가.중요도_점수).name}(${form.환경영향평가.중요도_점수})`}}</div>
              <ml-input v-else
                        textAlign="center"
                        readonly
                        :style="{color: getRating(form.환경영향평가.중요도_점수).color}"
                        :value="`${getRating(form.환경영향평가.중요도_점수).name}(${form.환경영향평가.중요도_점수})`"
              /></td>
            <!-- 환경영향평가.환경영향 -->
            <td v-if="rowIndex === 0" :rowspan="form.환경영향평가.list.length" class="align-top">
              <div v-if="isPrint" class="print-input">{{form.환경영향평가.환경영향 || '0'}}</div>
              <ml-input v-else textAlign="center" :value="form.환경영향평가.환경영향" readonly/></td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- 환경요소 평가 -->
    <div v-if="form.환경영향평가.환경요소_평가.length > 0" class="mt-7">
      <div class="mb-4">
        <div class="flex flex-wrap items-center justify-start gap-3">
          <h5><i class="dot"></i>환경요소 평가</h5>
          <div class="ml-auto"></div>
        </div>
      </div>

      <div class="overflow-x-auto">
        <table v-for="(환경요소, index) in ['대기', '소음진동', '수질', '폐기물', '토양', '에너지', '천연자원', '생태계']"
               v-if="form.환경영향평가.환경요소_평가.indexOf(환경요소) !== -1"
               :key="`환경요소_${환경요소}`"
               class="mb-4"
        >
          <tr>
            <th colspan="3">{{ 환경요소평가[환경요소].title }}</th>
          </tr>
          <tr>
            <th>영향등급</th>
            <th>평가기준</th>
            <th>평가</th>
          </tr>
          <tr v-for="data in 환경요소평가[환경요소].data">
            <td class="p-3 text-center">{{ data.영향등급 }}</td>
            <td class="p-3 whitespace-pre-line">{{ data.평가기준 }}</td>
            <td class="p-3 text-center">
              <span v-if="isPrint" class="print-radio">
                <i><feather-icon v-if="form.환경요소평가[환경요소] === data.평가 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>
              </span>
              <vs-radio v-else
                        v-model="form.환경요소평가[환경요소]" :disabled="isPrint || board.readonly" :vs-name="`radio_${환경요소}`" :vs-value="data.평가"/>
            </td>
          </tr>
        </table>
      </div>
    </div>

    <!-- 검출도 -->
    <div class="mt-7">
      <div class="mb-4">
        <div class="flex flex-wrap items-center justify-start gap-3">
          <h5><i class="dot"></i>검출도</h5>
          <div class="ml-auto"></div>
        </div>
      </div>

      <div class="overflow-x-auto">
        <table class="w-full">
          <colgroup>
            <col width="62"/>
            <col width="22"/>
            <col width="30"/>
          </colgroup>
          <tr>
            <th>평가기준</th>
            <th>평가</th>
            <th>비고</th>
          </tr>
          <tr v-for="(검출도, index) in form.검출도" :key="`검출도_${index}`">
            <td>{{ 검출도.title }}</td>
            <td>
              <div class="flex justify-center">
                <template v-if="isPrint">
                  <span v-for="data in [{label: 'Yes', value: true}, {label: 'No', value: false}]" class="ml-2">
                    <PrintRadio :value="검출도.평가 === data.value" :label="data.label"/>
                  </span>
                </template>
                <radio-group v-else flex v-model="검출도.평가" :readonly="isPrint || board.readonly" :items="[{label: 'Yes', value: true}, {label: 'No', value: false}]"/>
              </div>
            </td>
            <td>
              <div v-if="isPrint || board.readonly" class="print-input">{{ 검출도.비고 }}</div>
              <ml-input v-else v-model="검출도.비고" />
            </td>
          </tr>
        </table>
      </div>
    </div>

    <!-- 확률 -->
    <div class="mt-7">
      <div class="mb-4">
        <div class="flex flex-wrap items-center justify-start gap-3">
          <h5><i class="dot"></i>확률</h5>
          <div class="ml-auto"></div>
        </div>
      </div>

      <div class="overflow-x-auto">
        <table class="w-full">
          <colgroup>
            <col width="93"/>
            <col width="22"/>
          </colgroup>
          <tr>
            <th>평가기준</th>
            <th>평가</th>
          </tr>
          <tr v-for="(확률, index) in form.확률" :key="`검출도_${index}`">
            <td class="py-4">{{ 확률.title }}</td>
            <td>
              <div class="grid justify-center">
                <PrintCheckbox v-if="isPrint" :label="`Yes(${ 확률.점수 }}점)`" :value="확률.평가" color />
                <vs-checkbox v-else v-model="확률.평가" :disabled="isPrint || board.readonly">Yes({{ 확률.점수 }}점)</vs-checkbox>
              </div>
            </td>
          </tr>
        </table>
      </div>
    </div>

    <!-- 파일첨부 -->
    <file-upload-module :readonly="board.readonly" v-model="form.fileList" :is-print="isPrint || board.readonly" class="mt-8" />
    <popup-how-to-write v-model="showHowToWrite"/>
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import FileUploadModule from "@/views/modules/FileUploadModule.vue";
import WriteGridContainer from "@/components/WriteGridContainer.vue";
import CustomOptionSelector from "@/components/selector/CustomOptionSelector.vue";
import RadioGroup from "@/components/radio/RadioGroup.vue";
import DateSelector from "@/components/selector/DateSelector.vue";
import Select891Button from "@/views/boards/single-page/891/Select891Button.vue";
import TableCustom from "@/components/TableCustom.vue";
import PopupHowToWrite from "@/views/boards/single-page/899/PopupHowToWrite.vue";
import {required} from "vuelidate/lib/validators";
import PrintRadio from "@/components/print/PrintRadio.vue";
import PrintCheckbox from "@/components/print/PrintCheckbox.vue";

export default {
  components: {
    PrintCheckbox,
    PrintRadio,
    PopupHowToWrite,
    TableCustom,
    Select891Button,
    DateSelector,
    RadioGroup,
    CustomOptionSelector,
    WriteGridContainer,
    FileUploadModule,
    FieldSelectModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  validations: {
    form: {
      stdInfo: {
        field_name: { required },
      },
    },
  },
  data() {
    return {
      showHowToWrite: false,
      form: {
        stdInfo: {},
        문서정보: {
          보안등급: '팀내',
          보존년한: 3,
        },
        평가정보: {},
        공정분류: {
          raw: undefined,
        },
        사용물질정보: [],
        환경영향평가: {
          list: [],
          환경요소_평가: [],
          환경요소_심각도: '',
          발생가능성_검출도: '',
          발생가능성_확률: '',
          발생가능성_점수: '',
          중요도_점수: 0,
          환경영향: '',
        },
        환경요소평가: {
          '대기': -1,
          '소음진동': -1,
          '수질': -1,
          '폐기물': -1,
          '토양': -1,
          '에너지': -1,
          '천연자원': -1,
          '생태계': -1,
        },
        검출도: [
          { 'title': '- 환경사고를 방지할 수 있는 관리방법 또는 예방시설/대책이 설정되어 있다.', '평가': true, '점수': 1, '비고': '' },
          { 'title': '- 정기적인 점검 및 모니터가 되고 있다.', '평가': true, '점수': 1, '비고': '' },
          { 'title': '- 정기적으로 관련자에게 교육훈련이 실시되고 있다.', '평가': true, '점수': 1, '비고': '' },
          { 'title': '- 비상사태를 대비한 비상대응 절차가 수립되어 있다.', '평가': true, '점수': 1, '비고': '' },
        ],

        // 점수 - check 했을 시 (평가 = true 인 경우) 받을 수 있는 점수
        확률: [
          { 'title': '- 정기적으로 관련자에게 교육훈련이 실시되고 있다.', '평가': false, '점수': 3, '비고': '' },
          { 'title': '- 과거에 환경사고는 없었으나 발생 가능성이 있다.', '평가': false, '점수': 2, '비고': '' },
          { 'title': '- 발생 가능성이 없다.', '평가': false, '점수': 1, '비고': '' },
        ],

        fileList: [],
      },

      환경요소평가: {
        대기: {
          title: '1. 대기오염영향도 평가기준',
          data: [
            {
              영향등급: '3',
              평가기준: '- 대기오염물질이 대기환경보전법상 배출허용기준을 초과할 때\n' +
                '- 대기오염물질로 인한 민원발생이 1회/주이상 발생시(인터넷,전화,관청)\n' +
                '- 대기방지시설이 1회/반기 이상 비정상으로 가동\n' +
                '- 대기방지시설이 전혀 가동되지 않음',
              평가: 3,
            },
            {
              영향등급: '2',
              평가기준: '- 대기오염물질이 내부관리기준을 초과하고 대기환경보전법상 배출허용기준 이내일 때\n' +
                '- 대기오염물질로인한 민원발생이 1회/월이상 발생시(인터넷,전화,관청)\n' +
                '- 대기방지시설이1회/년이상 비정상으로 가동(배출허용기준이내)\n' +
                '- 비산먼지/악취다량 발생',
              평가: 2,
            },
            {
              영향등급: '1',
              평가기준: '- 대기오염물질이내부관리기준 이내일 때\n' +
                '- 대기오염물질로인한 민원발생이 1회/반기이상 발생시(인터넷,전화,관청)\n' +
                '- 대기방지시설이정상 가동\n' +
                '- 비산먼지/악취소량 발생',
              평가: 1,
            },
            {
              영향등급: '0',
              평가기준: '- 대기오염물질이배출되지 않음\n' +
                '- 대기오염물질로인한 민원이 발생하지 않을 때',
              평가: 0,
            },
          ]
        },
        소음진동: {
          title: '2. 소음/진동영향도 평가기준',
          data: [
            {
              영향등급: '3',
              평가기준: '- 공장부지경계선에서 소음/진동이허가배출기준을 초과하거나 인근지역 주민으로부터 민원이 1회/월 이상 발생',
              평가: 3,
            },
            {
              영향등급: '2',
              평가기준: '- 공장부지 경계선에서 소음/진동이허가배출기준 이내이며 인근지역 주민으로부터 민원이 1회/월 이상 발생',
              평가: 2,
            },
            {
              영향등급: '1',
              평가기준: '- 공장부지경계선에서 소음/진동이허가배출기준 이내이며 인근지역 주민으로부터 민원 발생이 없음',
              평가: 1,
            },
            {
              영향등급: '0',
              평가기준: '- 소음/진동이발생하지 않음',
              평가: 0,
            },
          ]
        },
        수질: {
          title: '3. 수질영향도 평가기준',
          data: [
            {
              영향등급: '3',
              평가기준: '- 재이용수/기타용수/유류/유해화학물질이하천으로 유출될 경우\n' +
                '- 오수정화시설방류수가 배출허용기준(BOD,SS)을 초과할때\n' +
                '- 폐수처리시설방류수가 허가배출기준을 초과할 때',
              평가: 3,
            },
            {
              영향등급: '2',
              평가기준: '- 오수정화시설방류수가 내부관리기준을 초과하나 배출허용기준(BOD, SS) 미만일 때\n' +
                '- 수처리시설내로 유입되어 수질에 심각한 영향을 미침\n' +
                '- 폐수처리시설방류수가 내부관리기준을 초과하나 허가배출기준 미만일 때',
              평가: 2,
            },
            {
              영향등급: '1',
              평가기준: '- 오수정화시설방류수가 내부관리기준(BOD,SS) 미만일 때\n' +
                '- 수처리시설내로 유입되어 수질에 영향을 미침\n' +
                '- 폐수처리시설방류수가 내부관리기준 미만일 때',
              평가: 1,
            },
            {
              영향등급: '0',
              평가기준: '- 공정/활동 중발생하는 폐수를 전량 재이용함(수처리시설 내 한함)',
              평가: 0,
            },
          ]
        },
        폐기물: {
          title: '4. 폐기물영향도 평가기준',
          data: [
            {
              영향등급: '3',
              평가기준: '- 지정폐기물이 다량 발생되어 재활용되지 않는 경우',
              평가: 3,
            },
            {
              영향등급: '2',
              평가기준: '- 지정폐기물이다량 발생되어 재활용되는 경우\n' +
                '- 지정폐기물이소량 발생되어 재활용이 안되는 경우\n' +
                '- 사업장폐기물이다량 발생되어 재활용되는 경우',
              평가: 2,
            },
            {
              영향등급: '1',
              평가기준: '- 지정폐기물이소량 발생되어 재활용되는 경우\n' +
                '- 사업장폐기물이다량 발생되어 재활용되는 경우\n' +
                '- 사업장폐기물이소량 발생되어 재활용이 안되는 경우',
              평가: 1,
            },
            {
              영향등급: '0',
              평가기준: '- 사업장폐기물이 소량 발생되어 재활용되는 경우',
              평가: 0,
            },
          ]
        },
        토양: {
          title: '5. 토양영향도 평가기준',
          data: [
            {
              영향등급: '3',
              평가기준: '- 토양오염물질이유출되어 토양에 심각한 영향을 미침\n' +
                '- 토양오염물질이반복적으로 유출되어 토양이 오염된 상태로 지속됨',
              평가: 3,
            },
            {
              영향등급: '2',
              평가기준: '- 토양오염물질이유출되나 영향이 적음\n' +
                '- 토양오염물질이일부 유출되나 사내에서 즉시 복구 가능하여 영향을 제거할 수 있음',
              평가: 2,
            },
            {
              영향등급: '1',
              평가기준: '- 토양오염물질을취급/보관/운송사용하지 않거나, 사용하나유출되지 않음\n' +
                '- 토양오염물질이유출되어도 즉시 처리되어 토양오염에 영향이 없음',
              평가: 1,
            },
            {
              영향등급: '0',
              평가기준: '- 토양오염의 영향이 없음',
              평가: 0,
            },
          ]
        },
        에너지: {
          title: '6. 에너지영향도 평가기준',
          data: [
            {
              영향등급: '3',
              평가기준: '- 에너지를 다량 사용하며 에너지 절감대책이 없는 경우',
              평가: 3,
            },
            {
              영향등급: '2',
              평가기준: '- 에너지를다량 사용하나 에너지 절감대책이 있는 경우\n' +
                '- 에너지를소량 사용하나 에너지 절감대책이 없는 경우',
              평가: 2,
            },
            {
              영향등급: '1',
              평가기준: '- 에너지를소량 사용하나 에너지 절감대책이 있는 경우',
              평가: 1,
            },
            {
              영향등급: '0',
              평가기준: '- 에너지를 사용하지 않는 경우',
              평가: 0,
            },
          ]
        },
        천연자원: {
          title: '7. 천연자원영향도 평가기준',
          data: [
            {
              영향등급: '3',
              평가기준: '- 천연자원을다량 사용하며 재활용이 안되는 경우',
              평가: 3,
            },
            {
              영향등급: '2',
              평가기준: '- 천연자원을다량 사용하나 재활용 되는 경우\n' +
                '- 천연자원을다량 사용하나 대체자원이 있는 경우',
              평가: 2,
            },
            {
              영향등급: '1',
              평가기준: '- 천연자원을소량 사용하나 재활용이 안되는 경우',
              평가: 1,
            },
            {
              영향등급: '0',
              평가기준: '- 천연자원을소량 사용하며 재활용이 되는 경우\n' +
                '- 천연자원을사용하지 않는 경우',
              평가: 0,
            },
          ]
        },
        생태계: {
          title: '8. 생태계영향도 평가기준',
          data: [
            {
              영향등급: '3',
              평가기준: '- 생태계 영향물질이 일시에 다량 배출되어 직접 토양 하천 대기를 오염시킴',
              평가: 3,
            },
            {
              영향등급: '2',
              평가기준: '- 생태계영향물질 배출시 지정된보관시설로 유입되어 처리됨\n' +
                '- 생태계영향물질이 토양, 하천, 대기로직접 배출되나 소량으로 그 영향이 적음',
              평가: 2,
            },
            {
              영향등급: '1',
              평가기준: '- 생태계영향물질을 취급하나 배출되지 않음\n' +
                '- 생태계영향물질이 미량 배출되지만, 그 영향이 거의 없음',
              평가: 1,
            },
            {
              영향등급: '0',
              평가기준: '- 생태계 영향물질을 취급하지 않음',
              평가: 0,
            },
          ]
        },
      },
    };
  },
  computed: {
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {

        // 환경요소.심각도: form.환경요소 평가 점수 합산
        value.환경영향평가.환경요소_심각도 = Object.keys(value.환경요소평가).reduce((acc, key) => {
          if (value.환경요소평가[key] === -1) return acc;
          return acc + value.환경요소평가[key];
        }, 0);

        // 발생가능성.검출도: form.검출도 중 평가가 true 인 개수에 따른 점수 (1개이하 3점, 2개이상 2점, 4개이상 1점)
        const 검출도개수 = value.검출도.reduce((acc, item) => {
          if (item.평가) return acc + 1;
          return acc;
        }, 0);
        if (검출도개수 >= 4) {
          value.환경영향평가.발생가능성_검출도 = 1;
        } else if (검출도개수 >= 2) {
          value.환경영향평가.발생가능성_검출도 = 2;
        } else {
          value.환경영향평가.발생가능성_검출도 = 3;
        }

        // 발생가능성.확률: form.확률 중 평가가 true 인 항목의 점수 합산
        value.환경영향평가.발생가능성_확률 = value.확률.reduce((acc, item) => {
          if (item.평가) return acc + Number(item.점수);
          return acc;
        }, 0);

        // 발생가능성.점수: 발생가능성.검출도 * 발생가능성.확률
        value.환경영향평가.발생가능성_점수 = Number(value.환경영향평가.발생가능성_검출도) * Number(value.환경영향평가.발생가능성_확률);

        // 중요도.점수: ”환경요소_심각도“ x “발생가능성_점수“, 15점 이상은 중요환경영향 등록부 메뉴에 집계
        value.환경영향평가.중요도_점수 = Number(value.환경영향평가.환경요소_심각도) * Number(value.환경영향평가.발생가능성_점수);
        console.log("중요도_점수", value.환경영향평가.환경요소_심각도, value.환경영향평가.발생가능성_점수)

        // 환경영향: “환경요소_평가” 체크리스트에서 점수가 높은 환경요소 평가를 선정하여 표기 (동일 점수일 경우 모두 표기)
        const 환경요소평가_keys = Object.keys(value.환경요소평가);
        const points = {}
        for (const key of 환경요소평가_keys) {
          if (!points[value.환경요소평가[key]]) points[value.환경요소평가[key]] = [];
          points[value.환경요소평가[key]].push(key)
        }
        const maxPoint = Math.max(...Object.keys(points));
        if (maxPoint > 0) {
          value.환경영향평가.환경영향 = points[maxPoint].map(환경영향 => `${환경영향}영향`).join(', ');
        } else {
          value.환경영향평가.환경영향 = '없음';
        }

        this.$emit("input", value);
      },
    },
  },
  created() {
    const keys = Object.keys(this.form);
    for (const key of keys) {
      if (this.value[key]) {
        this.form[key] = this.value[key];
      }
    }

    // TODO: created 가 두번 호출되는 문제가 있다. 원인 파악 필요 !!!!!
    if (this.form.환경영향평가.list.length === 0) {
      for (let i = 0; i<15; i++) {
        this.add_환경영향평가();
      }
    }
  },
  methods: {

    validate() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        if (!this.$v.form.stdInfo.field_name.required) return "사업장명을 반드시 입력해야 합니다";
      }
    },

    add_환경영향평가() {
      this.form.환경영향평가.list.push({
        배출물질: '',
        배출량: { label: '', unit: 'Kg/월', unit_기타: '' },
      });
    },

    // 문서 우측 상단 버튼들
    // 커스텀 버튼을 넣고 싶은 경우, tab/Index.vue 의 writeApprovalButtonsTemplate 함수를 참고하여 Json 작성
    // setApprovalButtons(template) {
    //   const 개정 = JSON.parse(JSON.stringify(template.resend))
    //   개정.content = "개정";
    //   개정.shouldShow.custom = ["approved"].indexOf(this.board.statusCode) > -1 // 승인된 경우에만 개정 가능
    //   개정.emits.click = (func) => {
    //     //  개정시 데이터 변경 (num: +1, date: new Date())
    //     this.form.revision.num += 1;
    //     this.form.revision.date = new Date();
    //     this.form.위험성평가정보.평가일자 = new Date().format("yyyy-MM-dd");
    //
    //     func.resend("개정 할 경우\n기존 문서는 유지되고, 내용이 복사되어 임시저장 됩니다.\n개정 하시겠습니까?");
    //   }
    //
    //   const saveFunc = template.save.emits.click
    //   template.save.emits.click = (func) => {
    //
    //     if (this.is위험도20) {
    //       this.popup.warning20 = true;
    //     } else {
    //       saveFunc(func)
    //     }
    //   }
    //   return [ 개정, template.resend, template.print, template.delete, template.move, template.save ]
    // },


    onSelectProcess (raw) {
      this.form.공정분류.팀명 = raw.팀명
      this.form.공정분류.공장명 = raw.공장명
      this.form.공정분류.공정명 = raw.공정명
      this.form.공정분류.상태 = raw.상태
      this.form.공정분류.활동명 = raw.활동명
    },

    onChangeCheck (checkList, value) {
      const index = checkList.indexOf(value);
      if (index === -1) {
        checkList.push(value);
      } else {
        checkList.splice(index, 1);
      }
    },

    getRating (point) {
      if (point >= 25) return { name: 'H', color: '#E42728' }
      else if (point >= 15) return { name: 'M', color: '#EA5455' }
      else if (point >= 5) return { name: 'L', color: '#FF9F43' }
      else return { name: 'N', color: '#28C76F' }
    }
  }
};
</script>
<style lang="scss" scoped>
table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
  border-top:1px solid #cdcdcd;
  border-left: 1px solid #cdcdcd;

  thead {  z-index: 0 !important; }
  th {
    background: #f9f9f9;
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 18px;
    color: #3c3c3c;

    border-right: solid 1px #cdcdcd;
    border-bottom: solid 1px #cdcdcd;
    padding: 16px 0;
    text-align: center;
  }
  td {
    background: #fff !important;
    border-right: solid 1px #cdcdcd;
    border-bottom: solid 1px #cdcdcd;
    padding: 6px;
  }
}
</style>
